import { DatePipe } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Regulation } from 'src/app/models/regulation';
import { RegulationCategory } from 'src/app/models/regulation-category';
import { RegulationService } from 'src/app/services/regulasi/regulation.service';
import { lastValueFrom } from 'rxjs';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-form-regulasi',
  templateUrl: './form-regulasi.component.html',
  styleUrls: ['./form-regulasi.component.css']
})
export class FormRegulasiComponent implements OnInit {

  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  isNew = !this.data;
  isLoading = false;
  regulations: Regulation[] = [];
  categories: RegulationCategory[] = [];
  title = new FormControl('', Validators.required);
  category = new FormControl(-1, [Validators.required]);
  form: any = {
    title: null,
    category: null,
  };

  fileAttr = 'Pilih File';
  fileSelected: File | undefined;

  constructor(
    public datepipe: DatePipe,
    public matDialogRef: MatDialogRef<FormRegulasiComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Regulation,
    private regulationService: RegulationService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    if (!this.isNew) {
      this.title.setValue(this.data.title);
      this.category.setValue(this.data.category?.id);
    }
    this.regulationService.getCategories().subscribe((data) => {
      this.categories = [
        {
          id: -1,
          name: 'Pilih',
        },
        ...data.categories
      ];
    });
  }

  async onSubmit(): Promise<void> {
    this.isLoading = true;
    console.log(this.data);
    var regulation: Regulation;
    if (this.isNew) {
      regulation = {
        title: this.title.value,
        categoryId: this.category.value,
        file: this.fileSelected,
      };
    } else {
      regulation = {
        id: this.data.id,
        title: this.title.value,
        categoryId: this.category.value,
        file: this.fileSelected,
      };
    }
    var response = await lastValueFrom(this.regulationService.upload(regulation));
    if (response) {
      var text = this.isNew ? "diupload" : "diubah";
      this.showSnackBar('Regulasi berhasil ' + text);
      this.matDialogRef.close(true);
      this.isLoading = false;
    }
  }

  onCategorySelection(event: MatSelectChange) { }

  uploadFileEvt(imgFile: any) {
    if (imgFile.target.files && imgFile.target.files[0]) {

      const file = imgFile.target.files[0];
      this.fileSelected = file;
      this.fileAttr = file.name;

      if (this.fileInput != undefined) {
        this.fileInput.nativeElement.value = "";
      }
    } else {
      this.fileAttr = 'Pilih Berkas';
    }
  }

  downloadFile() {
    this.isLoading = true;
    if (this.data.realFile) {
      this.regulationService.getDownload(this.data.realFile).subscribe((response: any) => {
        let blob: any = new Blob([response], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        //window.open(url);
        saveAs(blob, this.data.realFile);
      }), (error: any) => console.log('Error downloading the file'),
        () => console.info('File downloaded successfully');
      this.isLoading = false;
    }
  }

  showSnackBar(message: string) {
    this.snackBar.open(message, 'OK', {
      duration: 3000,
    });
  }

  getTitleErrorMessage() {
    if (this.title.hasError('required')) {
      return 'Harus diisi';
    }

    return '';
  }

  getCategoryErrorMessage() {
    if (this.category.hasError('required')) {
      return 'Harus diisi';
    }

    return '';
  }

}
